export enum Access {
  VIEW = "VIEW",
  MODIFY = "MODIFY",
}

export enum PermissionCodes {
  LEVEL = "LEVEL",
  TRANSACTION = "TRANSACTION",
  ADMIN = "ADMIN",
  ACL = "ACL",
  ANALYTICS = "ANALYTICS",
  CHANNEL = "CHANNEL",
  POINT_TRANSFER = "POINT_TRANSFER",
  SEGMENT = "SEGMENT",
  SETTINGS = "SETTINGS",
  TECH_SETTINGS = "TECH_SETTINGS",
  CUSTOMER = "CUSTOMER",
  REWARDS = "REWARDS",
  AUDIT = "AUDIT",
  EVENT = "EVENT",
  LANGUAGE = "LANGUAGE",
  TRANSLATIONS = "TRANSLATIONS",
  STORES = "STORES",
  CAMPAIGN = "CAMPAIGN",
  REWARDS_CATEGORIES = "REWARDS_CATEGORIES",
  ISSUED_REWARDS = "ISSUED_REWARDS",
  CUSTOM_EVENT = "CUSTOM_EVENT",
  WALLET = "WALLET",
  WEBHOOK_SUBSCRIPTION = "WEBHOOK_SUBSCRIPTION",
  DATA_ANALYTICS = "DATA_ANALYTICS",
  DATA_ANALYTICS_CAMPAIGN = "DATA_ANALYTICS_CAMPAIGN",
  IMPORT = "IMPORT",
  EXPORT = "EXPORT",
  GROUP_OF_VALUES = "GROUP_OF_VALUES",
  BILLABLE_REPORTS = "BILLABLE_REPORTS",
  BULK_ACTIONS = "BULK_ACTIONS",
  GLOBAL_MANAGEMENT = "GLOBAL_MANAGEMENT",
  BADGE = "BADGE",
}

export type PermissionItem = {
  code: `${PermissionCodes}`;
  name: string;
  description?: string;
};

export type PermissionCategory = {
  category?: string;
  items: PermissionItem[];
};

export type Permission = {
  access: string;
  resource: string;
};

type PermissionBackendModel = {
  access: string;
  filterQuery: string;
  id: string;
  resource: string;
  role: string;
};

export type RoleBackendModel = {
  default: boolean;
  id: string;
  master: boolean;
  name: string;
  permissions: PermissionBackendModel[];
  role: string;
  stores: string[];
};

export type RoleFields = {
  default: boolean;
  name: string;
  permissions: Permission[];
  stores?: string[];
};
